import type { Category } from "../../../shared/types";
import { useCategories } from "../../../shared/stores/category-store";

interface HabitAddExpandedProps {
  readonly showCategoryPicker: boolean;
  readonly selectedCategory: Category;
  readonly onCategoryChange: (category: Category) => void;
  readonly frequency: "daily" | "weekly";
  readonly onFrequencyChange: (frequency: "daily" | "weekly") => void;
}

export function HabitAddExpanded({
  showCategoryPicker,
  selectedCategory,
  onCategoryChange,
  frequency,
  onFrequencyChange,
}: HabitAddExpandedProps) {
  const { categories, labels, dotColors } = useCategories();

  return (
    <div className="flex flex-col gap-3 border-t border-border/60 px-3 py-3 bg-surface-alt/50">
      {/* Fréquence */}
      <div>
        <span className="text-[10px] text-ink-faint uppercase tracking-wide mb-1.5 block">
          Fréquence
        </span>
        <div className="flex gap-1.5">
          {([
            { value: "daily" as const, label: "Quotidien" },
            { value: "weekly" as const, label: "Hebdo" },
          ] as const).map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => onFrequencyChange(opt.value)}
              className={`px-2.5 py-1 text-[11px] font-medium rounded-md transition-colors ${
                frequency === opt.value
                  ? "bg-accent text-white"
                  : "text-ink-muted hover:text-ink hover:bg-surface"
              }`}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>

      {/* Catégories */}
      {showCategoryPicker && (
        <div>
          <span className="text-[10px] text-ink-faint uppercase tracking-wide mb-1.5 block">
            Catégorie
          </span>
          <div className="flex gap-1.5 flex-wrap">
            {categories.map((cat) => (
              <button
                key={cat}
                type="button"
                onClick={() => onCategoryChange(cat as Category)}
                className={`flex items-center gap-1.5 px-2.5 py-1 text-[11px] font-medium rounded-md transition-colors ${
                  selectedCategory === cat
                    ? "bg-accent text-white"
                    : "text-ink-muted hover:text-ink hover:bg-surface"
                }`}
              >
                <div className={`w-1.5 h-1.5 rounded-full ${dotColors[cat] ?? "bg-gray-400"}`} />
                {labels[cat]}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
